export const MAX_ALLOWED_PER_FLOOR = 200;
